import blacklist from './blacklist';

export default {
  namespaced: true,
  modules: {
    blacklist,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/blacklist/index.js